import React from "react";
import Skeleton from "react-loading-skeleton";

const SiteWiseInspectionStats = ({ data, loading = true }) => {
  const skeletonRows = Array.from({ length: 4 });

  return (
    <>
      <div className="machines-list">
        <div className="page-title m-0">
          <h5>
            Site Wise <span>Inspection Report</span>
          </h5>
        </div>

        <div className="table-responsive machinelist workflowtb mt-3" style={{ minHeight: "auto" }}>
          <table className="table align-middle table-nowrap mb-0">
            <thead>
              <tr>
                <th className="text-center">S.No</th>
                <th>Site</th>
                <th>Job Designation</th>
                <th>Inspection Assignee</th>
                <th className="text-center">Inspections Score</th>
                <th className="text-center">Inspection Count</th>
                <th className="text-center">Finding Count</th>
              </tr>
            </thead>
            <tbody>
              {loading
                ? skeletonRows.map((_, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <Skeleton width={20} />
                      </td>
                      <td>
                        <Skeleton width={100} />
                      </td>
                      <td>
                        <Skeleton width={100} />
                      </td>
                      <td>
                        <Skeleton width={100} />
                      </td>
                      <td className="text-center">
                        <Skeleton width={40} />
                      </td>
                      <td className="text-center">
                        <Skeleton width={40} />
                      </td>
                      <td className="text-center">
                        <Skeleton width={40} />
                      </td>
                    </tr>
                  ))
                : !!data?.length &&
                  data?.map((user, index) => (
                    <tr key={`${user.uuid}-${user.siteId}`}>
                      <td className="text-center">{index + 1}</td>
                      <td>{user?.siteName}</td>
                      <td>{user?.designation}</td>
                      <td>{user?.name}</td>
                      <td className="text-center">{user?.inspectionScore?.toFixed(2)}</td>
                      <td className="text-center">{user?.inspectionCount}</td>
                      <td className="text-center">{user?.findingCount}</td>
                    </tr>
                  ))}
            </tbody>
          </table>
          {data?.length === 0 && !loading && <p className="text-center mt-5 font-bold w-100">No Data Found</p>}
        </div>
      </div>
    </>
  );
};

export default SiteWiseInspectionStats;
